/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Features_From_CoachInputs */

const en_features_from_coach = /** @type {(inputs: Features_From_CoachInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`From ${i?.name}, just now`)
};

const pl_features_from_coach = /** @type {(inputs: Features_From_CoachInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Od ${i?.name}, przed chwilą`)
};

/**
* | output |
* | --- |
* | "From {name}, just now" |
*
* @param {Features_From_CoachInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_from_coach = /** @type {((inputs: Features_From_CoachInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_From_CoachInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_from_coach(inputs)
	return en_features_from_coach(inputs)
});